import React, { useState } from 'react'
import { Label } from 'reactstrap'
import Conditions from '../Conditions'

const ConditionsCheckBox = ({
  checkbox,
  setCheckbox,
  basvuru_sartlari_title,
  basvuru_sartlari_aciklama,
  style = {},
  kisa_metin = 'Yukarıdaki katılım koşullarını ve bilgilendirme metnini okudum, anladım ve kabul ediyorum. Başvuru bilgilerimin doğru olduğunu ve başvuruyu kendi adıma yaptığımı beyan ediyorum.',
}) => {
  const [modal, setModal] = useState(false)
  const toggleSartlar = (e) => {
    if (e?.stopPropagation) e.stopPropagation()
    setModal(!modal)
  }

  return (
    <div
      className='d-flex'
      style={
        style
          ? { ...style }
          : {
              display: 'flex',
              justifyContent: 'flex-start',
              marginTop: '1rem',
              marginLeft: '1rem',
              marginRight: '1rem',
            }
      }
    >
      <div className='inputContainer' style={{ flexShrink: 0, paddingTop: '0.15rem' }}>
        <input
          style={{
            width: '1.1rem',
            height: '1.1rem',
            accentColor: '#285843',
            cursor: 'pointer',
          }}
          type='checkbox'
          value={checkbox}
          checked={checkbox}
          onChange={() => setCheckbox(!checkbox)}
        />
      </div>
      <div style={{ flex: 1, marginLeft: '0.6rem' }}>
        <Label
          style={{
            fontSize: '0.8rem',
            lineHeight: 1.4,
            marginBottom: '0.25rem',
            color: '#285843',
            cursor: 'pointer',
          }}
          onClick={() => setCheckbox(!checkbox)}
        >
          {kisa_metin}
        </Label>
        <div
          onClick={toggleSartlar}
          style={{
            fontSize: '0.75rem',
            fontWeight: 700,
            color: '#285843',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Bilgilendirme metnini oku
        </div>
      </div>
      <Conditions toggle={toggleSartlar} modal={modal} basvuruSartlariTitle={basvuru_sartlari_title} basvuru_sartlari_aciklama={basvuru_sartlari_aciklama} />
    </div>
  )
}

export default ConditionsCheckBox
